export const legalization_format_item = (item) => {
  const { servico_forma_pagamento } = item;

  if (
    servico_forma_pagamento[0].forma_de_pagamento.descricao.includes(
      'BENEFÍCIO'
    )
  ) {
    item.stringParcela = 'BENEFÍCIO';
  } else {
    const parcelas = servico_forma_pagamento.map((forma) => {
      return forma.forma_de_pagamento.parcelas;
    });
    const maior_parcela = Math.max.apply(null, parcelas);
    const stringParcela =
      maior_parcela === 1 ? 'a vista' : `até ${maior_parcela}x`;
    item.stringParcela = `pag. ${stringParcela}`;
  }
};
